import React, { useRef, useCallback } from 'react';
import {useWebViewStore} from "./useWebViewStore";
import WebViewWrapper from './WebViewWrapper';

const CustomWebViewManager = () => {
    const { customView } = useWebViewStore();
    const mountedInstancesRef = useRef<Map<string, HTMLElement>>(new Map());
    
    // Track mounted instances
    const handleWebViewMount = useCallback((id: string, url: string, element: HTMLElement) => {
        mountedInstancesRef.current.set(id, element);
        console.log(`WebView ${id} mounted`);
    }, []);
    
    return (
        <>
        { customView && <div 
            id="custom-app-stack"
            style={{ 
                display: 'block',
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                backgroundColor: '#fff'
            }}
        >
            <WebViewWrapper
                key={customView.id}
                webview={customView}
                isActive={true}
                onMount={handleWebViewMount}
                onReady={() => {}}
            />
        </div> }
        </>
    );
};

export default React.memo(CustomWebViewManager);